import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useSeo } from "../lib/seo";

export default function CookiesPage() {
  useSeo({
    title: "Cookies at BookFreely",
    description:
      "How BookFreely uses cookies for essential, functional, analytics, and marketing purposes — and how to manage your preferences.",
    path: "/cookies",
  });
  const openPrefs = () => window.dispatchEvent(new CustomEvent("bf-open-cookie-prefs"));

  const Section = ({ title, children, testid }) => (
    <div data-testid={testid} className="rounded-2xl border p-5 sm:p-6"
         style={{ borderColor: "var(--gf-border)", background: "var(--gf-bg)" }}>
      <h2 className="font-display text-xl sm:text-2xl" style={{ color: "var(--gf-text)" }}>{title}</h2>
      <div className="mt-3 text-sm sm:text-base leading-relaxed space-y-2" style={{ color: "var(--gf-text-soft)" }}>
        {children}
      </div>
    </div>
  );

  return (
    <div className="App">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <div className="text-xs font-medium" style={{ color: "var(--gf-text-soft)" }}>PRIVACY</div>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2 leading-tight" style={{ color: "var(--gf-text)" }}>
          Cookies at BookFreely
        </h1>
        <p className="mt-4 text-base sm:text-lg" style={{ color: "var(--gf-text-soft)" }}>
          We use a small number of cookies to keep the website safe and simple. Here's what each category is for — in plain English.
        </p>

        <div className="mt-8 space-y-4">
          <Section title="Essential" testid="cookies-section-essential">
            <p>These keep you signed in and your account secure. They also help us block fraud and prevent someone else from using your session.</p>
            <p>Because they're required for the platform to work, they can't be turned off. They never track you for advertising and never leave BookFreely.</p>
          </Section>
          <Section title="Functional" testid="cookies-section-functional">
            <p>These remember things you set up — like your last search area, your favourite businesses, and dashboard filters — so you don't have to redo them every visit.</p>
            <p>Turn these off any time; the website will still work, you'll just re-set your preferences when you come back.</p>
          </Section>
          <Section title="Analytics" testid="cookies-section-analytics">
            <p>Optional analytics are <b>currently disabled</b>. No analytics provider loads and no analytics data is collected, even if a visitor accepts analytics cookies. Before enabling analytics in the future, BookFreely will update this policy to accurately explain what is collected and will continue requiring consent.</p>
          </Section>
          <Section title="Marketing" testid="cookies-section-marketing">
            <p>Optional and off by default. If we ever add ads or retargeting, this is where you would control them. Right now BookFreely runs no ad tech, and we do not sell or share your personal information.</p>
          </Section>
        </div>

        <div className="mt-10 rounded-2xl border p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
             style={{ borderColor: "var(--gf-border)", background: "var(--gf-surface)" }}>
          <div>
            <div className="font-display text-lg" style={{ color: "var(--gf-text)" }}>Change your choices any time</div>
            <div className="text-sm mt-1" style={{ color: "var(--gf-text-soft)" }}>Your cookie choices are saved on this device. You can update them whenever you want.</div>
          </div>
          <button
            data-testid="cookies-open-prefs-btn"
            onClick={openPrefs}
            className="rounded-md px-5 py-2.5 text-sm font-medium"
            style={{ background: "var(--gf-accent)", color: "var(--gf-on-accent)" }}
          >
            Manage cookie preferences
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
